import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { useId } from 'react';
import { Checkbox, CheckboxProps } from './Checkbox';
import { CheckboxInputProps } from './Checkbox.Input';
import { CheckboxLabelProps } from './Checkbox.Label';

export interface StandaloneCheckboxProps extends StandaloneComponentProps {
  label?: string;
  name?: CheckboxInputProps['name'];
  value?: CheckboxInputProps['value'];
  options?: CheckboxProps & {
    $input?: Omit<CheckboxInputProps, 'name' | 'value'>;
    $label?: CheckboxLabelProps;
  };
}

export const StandaloneCheckbox: StandaloneComponent<StandaloneCheckboxProps> = ({
  options,
  name,
  value,
  label,
  ...props
}) => {
  const { $input: inputProps, $label: labelProps, variant, ...baseProps } = options ?? {};

  const id = useId();

  return (
    <Checkbox {...{ variant }} {...baseProps} {...props}>
      <Checkbox.Input id={id} type="checkbox" {...{ variant, name, value }} {...inputProps} />
      <Checkbox.Label htmlFor={id} {...{ variant }} {...labelProps}>
        {label}
      </Checkbox.Label>
    </Checkbox>
  );
};

export default StandaloneCheckbox;
